module.exports = __webpack_public_path__ + "img/269.31da6065.png";